import "./Servicios.scss";

import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Menu from "../../components/Menu/Menu";
import { MenuProps } from "../../components/Menu/MenuTypes";
import { defaultMenuProps } from "../../constants/constants";
import { getApiServices, deleteApiService } from "../../services/apiService";
import { types } from "../../constants/constants";
import { TableProps } from "../../components/Table/TableTypes";
import Table from "../../components/Table/Table";
import Button from "../../components/Button/Button";
import dayjs from "dayjs";
import 'dayjs/locale/es';

const Servicios = (): React.ReactElement => {
  const navigate = useNavigate();
  const [menuProps] = useState<MenuProps>(defaultMenuProps);
  const [services, setServices] = useState<TableProps['items']>([]);
  const [limit] = useState<number>(types.PAGE_SIZE);
  const [offset, setOffset] = useState<number>(0);
  const [totalServices, setTotalServices] = useState<number>(0);
  const [actions, setActions] = useState<TableProps["actions"]>([]);
  const [sortDirection, setSortDirection] = useState<number>(1);
  const [sortBy, setSortBy] = useState<string>('created_at');

  useEffect(() => {
    setActions([
      { name: 'Editar', onClick: editAction, icon: 'pencil' },
      { name: 'Borrar', onClick: deleteAction, icon: 'deleteIcon' }
    ]);
  }, []);

  useEffect(() => {
    getServices();
  }, [sortBy, sortDirection]);

  const getServices = async (): Promise<void> => {
    getApiServices({ limit, offset, sortBy, sortDirection })
      .then(async (response: any) => {
        setTotalServices(response.total);
        const results: TableProps['items'] = response.services && response.services.map((service: any, index: number) => [
          { name: '#', value: index + 1 },
          { name: 'Id', value: service._id },
          { name: 'Título', value: service.title, sortable: true, index: 'title' },
          { name: 'Slug', value: service.slug },
          { name: 'Precio', value: service.price ? `${service.price}€` : '-', sortable: true, index: 'price' },
          { name: 'Creado', value: dayjs(service.created_at).format('DD/MM/YYYY'), sortable: true, index: 'created_at', className: 'text-center' }
        ]);
        setServices(results);
      })
      .catch((error: any) => {
        console.log(error.message);
        setServices([]);
      });
  };

  const loadMoreServices = async (): Promise<void> => {
    const offsetPage = offset + limit;
    getApiServices({ limit, offset: offsetPage, sortBy, sortDirection })
      .then(async (response: any) => {
        const results: TableProps['items'] = response.services && response.services.map((service: any, index: number) => [
          { name: '#', value: index + offsetPage + 1 },
          { name: 'Id', value: service._id },
          { name: 'Título', value: service.title, sortable: true, index: 'title' },
          { name: 'Slug', value: service.slug },
          { name: 'Precio', value: service.price ? `${service.price}€` : '-', sortable: true, index: 'price' },
          { name: 'Creado', value: dayjs(service.created_at).format('DD/MM/YYYY'), sortable: true, index: 'created_at', className: 'text-center' }
        ]);
        setOffset(offsetPage);
        setServices(services.concat(results));
      })
      .catch((error: any) => {
        console.log(error.message);
      });
  };

  const editAction = (id: string): void => navigate(`/servicios/${id}`);

  const deleteAction = async (id: string): Promise<void> => {
    if (!window.confirm('¿Estás seguro de que quieres eliminar este servicio?')) return;
    try {
      await deleteApiService(id);
      getServices();
    } catch (error: any) {
      alert('Error al eliminar el servicio');
    }
  };

  const doSortBy = (field: string): void => {
    setOffset(0);
    setSortBy(field);
    setSortDirection(sortDirection === 1 ? -1 : 1);
  };

  return (
    <React.Fragment>
      <div id="menu">
        <Menu items={menuProps.items} />
      </div>
      <div id="app-content">
        <header className="table-header mb-4">
          <h1>Servicios</h1>
          <Button className={'btn-orangebg ms-auto me-3'} value={'Añadir servicio'} onClick={() => navigate('/servicios/crear')} />
          <span>Total registros: {totalServices}</span>
        </header>
        {services && services.length
          ? <Table items={services} actions={actions} doSortBy={doSortBy} />
          : <p>No hay servicios</p>
        }
        {totalServices > services.length &&
          <div className="row mt-4">
            <div className="col-12 col-md-4 offset-md-4">
              <Button className={'btn-white m-auto'} value={'Cargar más'} onClick={loadMoreServices} />
            </div>
          </div>
        }
      </div>
    </React.Fragment>
  );
};

export default Servicios;
